export const roles = {
  USER_ROLE: 'user',
  CUSTOMER_ROLE: 'customer',
  API_USER_ROLE: 'apiuser',
};
